export default __webpack_public_path__ + "static/media/business-ahs-icon-3.7b449452.png";